var _filter, _linearGradient, _linearGradient2, _filter2, _filter3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 417.14 299.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1d254f",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 141.68,
    y1: 231.8,
    x2: 415.3,
    y2: 231.8,
    gradientTransform: "translate(13.62 -101.26) rotate(9.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8058f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b80ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-2",
    x1: 287.81,
    y1: 219.64,
    x2: 403.13,
    y2: 219.64,
    gradientTransform: "translate(12.6 -112.3) rotate(9.68)",
    xlinkHref: "#Degradado_sin_nombre_4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.45,100.75h95.52c.9,0,1.64.73,1.64,1.64v114.05c0,4.11-3.34,7.45-7.45,7.45h-83.58c-4.29,0-7.77-3.48-7.77-7.77v-113.73c0-.9.73-1.64,1.64-1.64Z",
    transform: "translate(-22.14 53.44) rotate(-9.33)",
    style: {
      fill: "none"
    }
  })), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1d254f",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1d254f",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.29,208.25c2.5-40.62,28.97-50.68,25.43-115.59-2.82-51.77,30.55-70.14,50.5-74.3,9.53-1.99,38.73,4.09,43.09,29.27,16.26,93.82,76.58,181.22-9.87,217.63-35.07,14.77-114.83,35.19-109.15-57.01Z",
    style: {
      fill: "#8058f1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.25,41.75L96.82,85.88c-4.72.78-7.91,5.23-7.14,9.94l29.83,181.48c.78,4.72,5.23,7.91,9.94,7.14l268.43-44.12c4.72-.78,7.91-5.23,7.14-9.94l-29.83-181.48c-.78-4.72-5.23-7.91-9.94-7.14ZM261.28,79.94l-53.44,8.78c-3,.49-6.06-1.25-6.81-4.2-.85-3.32,1.34-6.58,4.65-7.13l53.44-8.78c3-.49,6.06,1.25,6.81,4.2.85,3.32-1.34,6.58-4.65,7.13Z",
    style: {
      fill: "#f1f2f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.79,
    y: 101.76,
    width: 254.74,
    height: 144.61,
    rx: 5.87,
    ry: 5.87,
    transform: "translate(-24.94 42.72) rotate(-9.33)",
    style: {
      fill: "url(#Degradado_sin_nombre_4)",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.31,
    y: 132.02,
    width: 110.25,
    height: 16.37,
    rx: 4.18,
    ry: 4.18,
    transform: "translate(-20.31 31.61) rotate(-9.33)",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.22,
    y: 164.53,
    width: 72.9,
    height: 7.73,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(-24.87 32.18) rotate(-9.33)",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.19,
    y: 175.51,
    width: 97.78,
    height: 7.73,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(-26.46 34.67) rotate(-9.33)",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 189.57,
    width: 84.59,
    height: 7.73,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(-28.8 34.14) rotate(-9.33)",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.47,
    y: 201.5,
    width: 97.78,
    height: 7.73,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(-30.62 35.7) rotate(-9.33)",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.72,
    y: 215.95,
    width: 79.89,
    height: 7.73,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(-33.05 34.81) rotate(-9.33)",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.81,
    y: 100.75,
    width: 98.79,
    height: 123.14,
    rx: 9,
    ry: 9,
    transform: "translate(-22.14 53.44) rotate(-9.33)",
    style: {
      fill: "url(#Degradado_sin_nombre_4-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.82,17.4h27.33c7.87,0,14.26,6.39,14.26,14.26v49.23c0,.52-.42.95-.95.95h-53.94c-.52,0-.95-.42-.95-.95V31.65c0-7.87,6.39-14.26,14.26-14.26Z",
    transform: "translate(-5.01 37.88) rotate(-9.33)",
    style: {
      fill: "#b8aeff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.86,
    cy: 39.72,
    r: 12.17,
    style: {
      fill: "#1d254f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.32,133.36c.19-12.74,11.3-21.06,20.29-21.93,10.54-1.03,20.3,2.77,26.29,18.31,1.93,5,4.95,9.52,9.41,12.49,4.11,2.74,8.96,4.62,13.37,5.47,7.54,1.45,13.19,6.13,13.73,12.14.56,6.27-4.63,11.91-12.31,14.6,0,0-14.71,6.39-52.13,7.29-10.29.38-19.85-2.25-21.82-10.05-.61-2.42-.87-4.91.02-7.24,1.43-3.71,4.28-9.78,3.83-19.34-.37-7.95-.67-11.72-.67-11.72Z",
    style: {
      fill: "#d7cfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.65,169.85s-3.43,5.45-14.49,6.86l.17-.02c-11.05,1.41-15.75-3.01-15.75-3.01l1.23-35.3,18.77-2.39,10.06,33.86Z",
    style: {
      fill: "#f1f2f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,138.95c.94,7.4,5.26,17.98,9.12,20.17,3.14,1.78,8.86,1.05,14.14-1.32,5.27-2.37,20.24-12.35,18.73-24.21-1.51-11.86-12.35-20.24-24.21-18.73-11.86,1.51-19.51,10.49-17.78,24.09Z",
    style: {
      fill: "#f1f2f5",
      filter: "url(#drop-shadow-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.32,133.36c.19-12.74,11.3-21.06,20.29-21.93,10.54-1.03,20.3,2.77,26.29,18.31,1.93,5,4.95,9.52,9.41,12.49,4.11,2.74,8.96,4.62,13.37,5.47,7.54,1.45,13.19,6.13,13.73,12.14.7,7.88-7.7,14.78-18.69,16.05-20.35,2.35-26.44-13.25-28.77-23.02-1.83-7.68-2.54-12.34-1.1-17.91-14.41-.77-23.29-7.42-23.29-7.42,0,0-5.35,5.36-11.24,5.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.15 119.43 293.02 119.34 293.02 119.34 293.15 119.43",
    style: {
      fill: "#f1f2f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.65,169.85s-3.43,5.45-14.49,6.86l.17-.02c-11.05,1.41-15.75-3.01-15.75-3.01l-13.96,6.36c-4.36,1.99-6.76,6.73-5.79,11.42l15.37,73.86,60.76-7.75,1.73-84.85-28.05-2.87Z",
    style: {
      fill: "#1d254f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.67,263.83h0c5.89-.75,10.05-6.13,9.3-12.02l-8.88-69.58c-.75-5.89-6.13-10.05-12.02-9.3l-2.52.32c-6.06.77-10.25,6.43-9.23,12.45l11.39,69.26c.96,5.68,6.24,9.59,11.95,8.86Z",
    style: {
      fill: "#1d254f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.32,133.36c.19-12.74,11.3-21.06,20.29-21.93,10.54-1.03,20.3,2.77,26.29,18.31,1.93,5,4.95,9.52,9.41,12.49,4.11,2.74,8.96,4.62,13.37,5.47,7.54,1.45,13.19,6.13,13.73,12.14.7,7.88-7.7,14.78-18.69,16.05-20.35,2.35-26.44-13.25-28.77-23.02-1.83-7.68-2.54-12.34-1.1-17.91-14.41-.77-23.29-7.42-23.29-7.42,0,0-5.35,5.36-11.24,5.83Z",
    style: {
      fill: "#b8aeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.74,142.82c1.73.16,3.78-1.74,4.01-4.23.23-2.49-.99-4.63-2.71-4.79-.02,0-.05,0-.07,0-.83-.06-1.63.33-2.13.99h0",
    style: {
      fill: "#f1f2f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.29,255.75h0c4.81.75,9.31-2.54,10.06-7.35l8.87-56.83c.75-4.81-2.54-9.31-7.35-10.06l-2.06-.32c-4.95-.77-9.54,2.73-10.11,7.7l-6.82,57.15c-.54,4.7,2.72,8.98,7.39,9.71Z",
    style: {
      fill: "#1d254f"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 175.69,
    r: 2.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.52,
    cy: 188.69,
    r: 2.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.98,
    cy: 201.99,
    r: 2.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.25,
    cy: 214.7,
    r: 2.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.07,
    cy: 227.56,
    r: 2.75,
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.8d7628750c05124872373020627ea7a7.svg";
export { ForwardRef as ReactComponent };